
  <mat-card class="slidecontent">
    <div class="headcontent">
    
        <div class="pophead">
            <h3>Email Document</h3>
              <mat-icon  class="close" (click)="closeShareOpt(closeShare)">close</mat-icon>
          </div>
        </div>
          <div class="dialog_content">

            <div class="documentListing">

              <ng-container *ngFor="let document of selectedFileList; let i = index">

              <div class="doc placeholder" *ngIf="!document.fileType">   
                <span class="type"> <mat-icon>backup</mat-icon> </span>
                <div class="name">
                  {{ getplaceholdername(document.name) }}
                </div>
                <button class="remove" mat-icon-button (click)="removeDocument(document)"><mat-icon>cancel</mat-icon></button>
              </div>

              <div class="doc" *ngIf="document.fileType">
                <span class="type" *ngIf="document.fileType == 'pdf' || document.fileType == '.pdf'">
                  <img src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                 </span>

                <span class="type" *ngIf="document.fileType == 'doc' ||
                    document.fileType == 'docx'">
                    <img src="../../../../../assets/icons/fileType/doc_icon.svg" alt="Word File"/>
                 </span>

                <span class="type" *ngIf="document.fileType == 'xlsx' ||
                    document.fileType == 'xls' ||
                    document.fileType == 'csv' ||
                    document.fileType == 'ods'">
                  <img src="../../../../../assets/icons/fileType/excel_icon.svg" alt="excel File"/>
                </span>
                <span class="type" *ngIf="document.fileType == 'jpg' ||
                    document.fileType == 'jpeg' || 
                    document.fileType == 'image/jpeg'">
                    <img src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/>
                  </span>
                <span class="type" *ngIf="document.fileType == 'png' ||
                    document.fileType == 'gif' ||
                    document.fileType == 'tiff' ||
                    document.fileType == 'webp' ||
                    document.fileType == 'bmp'">
                    <img src="../../../../../assets/icons/fileType/020-png.svg" alt="png File"/>
                  </span>
                <span class="type" *ngIf="document.fileType == 'txt'">
                  <img src="../../../../../assets/icons/fileType/text_icon.svg" alt="txt File"/>
                  </span>
                <span class="type" *ngIf="document.fileType == 'ppt' ||
                    document.fileType == 'pptx'">
                    <img src="../../../../../assets/icons/fileType/021-ppt.svg" alt="ppt File"/>
                  </span>               
                <div class="name">
                  {{ getplaceholdername(document.name) }}
                </div>
                <button class="remove" mat-icon-button (click)="removeDocument(document)"><mat-icon>cancel</mat-icon></button>
              </div>
              </ng-container>

             
            </div>


            <ng-container>
              <div class="reminder">
                <div class="remind">                 
                </div>
    
                <ng-container>          
                 
    
                  <div class="block mt-10" >

                    <div class="emailWithButton">

                      <mat-form-field appearance="outline" class="mt-10 mb-10" style="position: relative;">
                        <mat-label>Add Email</mat-label>
                        <!-- <input matInput maxlength="50" placeholder="Type & Select" aria-label="State" [matAutocomplete]="auto"
                          (input)="searchCore($event.target.value)" 
                          > -->
                          <input matInput maxlength="100" class="form-control mtb-15" placeholder="Add email"
                          [(value)]="emailAssigned" (input)="emailCheck($event.target.value)" />                       
                         
  
                      </mat-form-field>
  
                      <button color="primary" *ngIf="addEmailButtonShow" (click)="addEmail()" mat-icon-button>
                        <mat-icon>add</mat-icon>
                      </button>

                    </div>

                    <ul class="selectedlist" *ngFor="let data of selectedAssignedTo">
                      <li>
                        <div class="userndetail">
                          <div class="userpic">                            
                            <span *ngIf="data.img==''" class="username">
                              {{data.shortName}}
                            </span>
                          </div>
                          <div class="details">                          
                            <p>{{data.email}}</p>
                          </div>
                          <div class="opt">
                            <button mat-icon-button>
                              <mat-icon (click)="removeEmail(data)">cancel</mat-icon>
                            </button>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
    
                
                 
                
                </ng-container>
    
              </div>
            </ng-container>             
      
          </div>
   
    
    <div class="actionBtn"> 
    <button mat-flat-button class="cancel" (click)="cancelShareOpt(closeShare)">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary"
    [disabled]="showAddButton==false" (click)="sendEmail()">Send
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
    </div>

</mat-card>




<div class="overlay" (click)="closeShareOpt(closeShare)"></div>


